import React, { InputHTMLAttributes } from 'react';

interface InputNumberBlockProps extends InputHTMLAttributes<HTMLInputElement> {}

const InputNumberBlock = (props: InputNumberBlockProps) => {
	const { ...nativeProps } = props;
	return (
		<>
			<input
				type="number"
				className="input-block"
				{...nativeProps}
			/>
		</>
	);
};

export default InputNumberBlock;
